var React = require('react');

function Clear (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M-241.508,18223.66a1.5,1.5,0,0,1-.105-2.117l4.547-5.018-4.547-5.018a1.506,1.506,0,0,1,.105-2.121,1.521,1.521,0,0,1,1.006-.389,1.513,1.513,0,0,1,1.116.494l4.368,4.824,4.372-4.824a1.508,1.508,0,0,1,2.122-.105,1.5,1.5,0,0,1,.1,2.121l-4.547,5.018,4.547,5.018a1.5,1.5,0,0,1-.1,2.117,1.5,1.5,0,0,1-1.011.389,1.5,1.5,0,0,1-1.111-.488l-4.372-4.826-4.368,4.826a1.5,1.5,0,0,1-1.113.49A1.494,1.494,0,0,1-241.508,18223.66Z","transform":"translate(242 -18208.998)","fill":"#707070"}));
}

Clear.defaultProps = {"width":"13.968","height":"15.053","viewBox":"0 0 13.968 15.053"};

module.exports = Clear;

Clear.default = Clear;
